export interface ICountryValues {
	country: string
	tfFullName: string
	copyRight: string
	address: IAddress
	links: () => ILinks
	productSpecific: IProductInformation[]
	chatInfo?: IChatInfo
}

interface IChatInfo {
	supportTitle: string
	liveChatText: string
}

export enum CountryValuesProductType {
	Card = 'Card',
	Deposit = 'Deposit',
	Deposit_Fixed = 'Deposit_Fixed',
	Loan = 'Loan',
	All = 'All',
}

interface IProductInformation {
	productType: CountryValuesProductType
	bankInformation?: IBankInformation
	contactInformation: IContactInformation
}

interface IContactInformation {
	email: string
	email2?: string
	phoneNumber?: string
	phoneNumber2?: string
	openingHours?: string
}

interface IBankInformation {
	iban: string
	bic: string
}

export interface ILinks {
	about?: ILinkProps
	forms?: ILinkProps
	financialDifficulties?: ILinkProps
	consumerLoan?: ILinkProps
	cookie: ILinkProps
	loanSecurity?: ILinkProps
	faq?: ILinkProps
	legal?: ILinkProps
	dataProtection?: ILinkProps
	cashLoan?: ILinkProps
	carLoan?: ILinkProps
	renovationLoan?: ILinkProps
	refinance?: ILinkProps
}

interface ILinkProps {
	title?: string
	link: string
}

interface IAddress {
	postalAddress?: string
	companyName: string
	addressLine1: string
	addressLine2?: string
	zipCodeAndCity: string
	country?: string
}
